import '../scss/main.scss';

import './react/agenda';

import Nav from './components/Nav';
import LoadImage from './components/LoadImage';
import Accordion from './components/Accordion';
import IsDraggable from './components/IsDraggable';
import NewsletterPopUp from './components/NewsletterPopUp';
import HideOnScroll from './components/HideOnScroll';
import SlideOnScroll from './components/SlideOnScroll';
import EnableFocus from './components/EnableFocus';
// import HeroOnScroll from './components/HeroOnScroll';
// import ScrollHijack from './components/ScrollHijack';
import VideoPlayer from './components/VideoPlayer';
import popUp from './components/popUp';

if (true) {
	EnableFocus.init();
}

document.querySelectorAll('.newsletter-pop-up-js').forEach((el) => {
	new NewsletterPopUp(el);
});

document.querySelectorAll('.js-popUp').forEach((el) => {
	new popUp(el);
});

document.querySelectorAll('.js-nav').forEach((el) => {
  new Nav(el);
});

document.querySelectorAll('.js-load-image').forEach((el) => {
  new LoadImage(el);
});

document.querySelectorAll('.js-accordion').forEach((el) => {
  new Accordion(el);
});

document.querySelectorAll('.js-is-draggable').forEach((el) => {
  new IsDraggable(el);
});

document.querySelectorAll('.js-hide-on-scroll').forEach((el) => {
  new HideOnScroll(el);
});

document.querySelectorAll('.js-slide-on-scroll').forEach((el) => {
	new SlideOnScroll(el);
 });

//  document.querySelectorAll('.js-hero-on-scroll').forEach((el) => {
// 	new HeroOnScroll(el);
//  });

//  document.querySelectorAll('.scroll-container').forEach((el) => {
// 	new ScrollHijack(el);
//  });


 document.querySelectorAll('.js-video-player').forEach((el) => {
	new VideoPlayer(el);
 });
